import React, { useState } from "react";
import { Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { StyledDropdown } from "./styles";
import credentialTypesConstants from "../../../../constants/credentialTypes";

const CategoryButton = styled.div`
  display: flex;
  min-width: 178px;
  height: 37px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  font-family: "Inter", sans-serif;
  padding: 6px 12px;
  border: 1px solid rgba(226, 232, 240, 1);
  border-radius: 4px;
  cursor: pointer;
  color: rgba(98, 116, 142, 1);
  background-color: white;
  transition: background 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: #f5f5f5;
  }
`;

// INFORMACP-4504: allowedTypes traz os tipos visiveis para o contrato (vindos de
// /accreditation/quota). Enquanto nao carregou (null/undefined) so a opcao "Todos" e oferecida —
// sem fallback para a lista completa, para nao expor tipo indevido em caso de falha.
const DropdownFilter = ({ onSelect, allowedTypes }) => {
  const intl = useIntl();
  const [selected, setSelected] = useState(intl.formatMessage({ id: "all2" }));

  const allOption = [{
    label: intl.formatMessage({ id: "all2" }),
    value: "ALL"
  }];

  const credentialTypes = [
    ...allOption,
    ...credentialTypesConstants().filter(({ value }) =>
      allowedTypes ? allowedTypes.includes(value) : false
    )
  ];

  const handleMenuClick = (e) => {
    const selectedCategory = credentialTypes.filter(
        (type) => type.value === e.key)[0];
    setSelected(selectedCategory.label);
    onSelect(selectedCategory.value);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {credentialTypes.map((category, index) => (
        <Menu.Item key={category.value}>
          {category.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <StyledDropdown
      overlay={menu}
      trigger={["click"]}
      style={{
        width: "fit-content",
      }}
    >
      <CategoryButton>
        {intl.formatMessage({ id: "category" })}: {selected} <DownOutlined />
      </CategoryButton>
    </StyledDropdown>
  );
};

export default DropdownFilter;
